import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ReactNode } from 'react';

const NOT_APPLICABLE_PLACEHOLDER = '—';

interface ConfigTableProps {
  children: ReactNode;
  columnLabels?: string[];
}

export function ConfigTableEmptyCell() {
  return (
    <TableCell align="center" sx={{ color: 'text.disabled' }}>
      {NOT_APPLICABLE_PLACEHOLDER}
    </TableCell>
  );
}

export default function ConfigTable({ children, columnLabels }: ConfigTableProps) {
  return (
    <TableContainer
      sx={{ border: 1, borderColor: 'divider', borderRadius: 1, maxWidth: 'sm', mt: 2 }}
    >
      <Table
        size="small"
        sx={{
          '& th, & td': { borderColor: 'divider' },
          '& tbody tr:last-child > *': { borderBottom: 0 },
        }}
      >
        {columnLabels && (
          <TableHead>
            <TableRow sx={(theme) => ({ backgroundColor: theme.semantic.surfaceSunken })}>
              {columnLabels.map((label, index) => (
                <TableCell
                  key={label}
                  align={index === 0 ? 'left' : 'center'}
                  sx={{ fontWeight: 600 }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
